import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Remove the HTML loader once React has mounted
const loader = document.getElementById("app-loader");
if (loader) {
  loader.classList.add("fade-out");
  setTimeout(() => loader.remove(), 350);
}
